/**
 * Post Tabs Setup
 *
 * Entry points for shared post tab switching behavior.
 */

import { PostSharedTabsListener } from "./post-tabs-listener";

interface SetupPostTabSwitchingParams {
    rootEl: Document | HTMLElement;
    onPreview: () => void;
}

class PostSharedTabsSetup {
    public static setupPostTabSwitching(params: SetupPostTabSwitchingParams): void {
        PostSharedTabsListener.setupPostTabSwitching(params);
    }

    public static cleanupPostTabSwitching(rootEl: Document | HTMLElement = document): void {
        PostSharedTabsListener.cleanupPostTabSwitching(rootEl);
    }
}

export { PostSharedTabsSetup };
